import { defineComponent } from 'vue'
import { RouterView } from 'vue-router'

import SimpleHeader from '@vuejs/components/common/SimpleHeader'
import { useGlobalStore } from '@vuejs/stores/GlobalStore'

export default defineComponent({
	name: 'UnsecuredApp',

	computed: {
		currentRoute() {
			return this.$route ? this.$route.fullPath : window.location.href
		},

		globalStore(): ReturnType<typeof useGlobalStore> {
			return useGlobalStore()
		},
	},

	beforeMount() {
		this.globalStore.currentUser = window.current_user
	},

	render() {
		return (
			<div
				class={`${String(this.$route.name)}-page unsecured-app w-screen max-w-full`}
				data-test={`${String(this.$route.name)}-page`}
			>
				<SimpleHeader hideLogout={true} />

				<RouterView />
			</div>
		)
	},
})
